import React, { useEffect, useState } from "react"
import { IConfigurationPublicationFTP } from "./PublicationConfigurationFTP.types"

interface Props
{
    updatingConfig: IConfigurationPublicationFTP | null
    updateConfig: (updatedConfig: IConfigurationPublicationFTP) => void
    createConfig: (createConfig: Omit<IConfigurationPublicationFTP, "IDConfigPublicationFTP">) => void
}

export default function ModalPublicationConfigurationFTP(props: Props) {
    const [ config, setConfig ] = useState<IConfigurationPublicationFTP>()

    const initialConfig = {
        IDConfigPublicationFTP: undefined, // or null, depending on your type
        Host: "",
        Port: 22,
        Login: "",
        Password: "",
        Path: "",
    }

    useEffect(() => {
        if (props.updatingConfig) {
            setConfig(props.updatingConfig)
        } else {
            // Initialize empty config for creation
            setConfig(initialConfig)
        }
    }, [ props.updatingConfig ])

    const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>, field: keyof IConfigurationPublicationFTP) => {
        if (!config) return

        let value: string | number = e.target.value

        if (field === "Port") {
            value = parseInt(value) || 0 // ensure port is a number
        }

        setConfig({
            ...config,
            [field]: value,
        })
    }

    const handleSave = () => {
        if (config) {
            if (config.IDConfigPublicationFTP) {
                props.updateConfig(config)
            } else {
                props.createConfig(config)
            }
        }
    }

    return (
        <div id="modalPublicationConfiguration" className="modal fade" tabIndex={-1} role="dialog" data-backdrop="static" data-keyboard="false">
            <div className="modal-dialog modal-dialog-centered modal-xl">
                <div className="modal-content border-0">
                    <div className="modal-header p-2 bg-light">
                        <h5 className="modal-title">{config?.IDConfigPublicationFTP ? "Modification de la configuration" : "Nouvelle configuration"}</h5>
                    </div>
                    <div className="modal-body">
                        <div className="d-flex flex-column" style={{ gap: "5px" }}>
                            {[ "Host", "Port", "Login", "Password", "Path" ].map((field) => (
                                <div key={field}>
                                    <span>{field}</span>
                                    <input
                                        type={field === "Port" ? "number" : "text"}
                                        className="form-control"
                                        value={config?.[field as keyof IConfigurationPublicationFTP] as string | number}
                                        onChange={(e) => handleInputChange(e, field as keyof IConfigurationPublicationFTP)}
                                    />
                                </div>
                            ))}
                        </div>
                    </div>
                    <div className="modal-footer">
                        <button type="button" onClick={() => setConfig(initialConfig)} className="btn btn-secondary" data-dismiss="modal">
                            Fermer
                        </button>
                        <button
                            type="button"
                            onClick={handleSave}
                            className="btn btn-primary"
                            data-dismiss="modal"
                            disabled={!config}
                        >
                            Enregistrer
                        </button>
                    </div>
                </div>
            </div>
        </div>
    )
}
